import React from 'react'

import { Box, Tab, Tabs } from '@mui/material'

import { VerticalTabPanel } from 'components/common'
import { SmsTemplate } from 'components/settings/CustomerSms/SmsTemplate'
import { SmsTemplateType } from 'generated/graphql'

import { EmailBoxSx, EmailTabSx } from '../SettingsStyles'

enum TabId {
  EtaUpdate,
  Delivered,
  Canceled,
  PackageLoaded
}

function commonProps(index: TabId) {
  return {
    id: `customer-sms-tab-${index}`,
    'aria-controls': `customer-sms-tabpanel-${index}`,
  }
}

const CustomerSms = () => {
  const [tabValue, setTabValue] = React.useState(0)

  const tabs = [
    {
      id: TabId.EtaUpdate,
      label: 'ETA Update',
      type: SmsTemplateType.EtaUpdate,
    },
    {
      id: TabId.Delivered,
      label: 'Booking Delivered',
      type: SmsTemplateType.Delivered,
    },
    {
      id: TabId.Canceled,
      label: 'Booking Canceled',
      type: SmsTemplateType.Canceled,
    },
    {
      id: TabId.PackageLoaded,
      label: 'Package on Board',
      type: SmsTemplateType.PackageLoaded,
    },
  ]

  const handleChange = (_, newValue: number) => {
    setTabValue(newValue)
  }

  return (
    <Box sx={EmailBoxSx}>
      <Tabs
        value={tabValue}
        onChange={handleChange}
        orientation='vertical'
        aria-label='customer sms tabs'
        variant='scrollable'
        sx={EmailTabSx}>
        {tabs.map((tab) => (
          <Tab label={tab.label} key={tab.id} {...commonProps(tab.id)} />
        ))}
      </Tabs>

      {tabs.map((tab) => (
        <VerticalTabPanel value={tabValue} index={tab.id} key={tab.id} px={3}>
          <SmsTemplate type={tab.type} label={tab.label} />
        </VerticalTabPanel>
      ))}
    </Box>
  )
}

export default CustomerSms
